import React, { Fragment } from 'react'
import TextSnippetTwoToneIcon from '@mui/icons-material/TextSnippetTwoTone'
import { Button, Modal, SvgIcon } from '../../../../components'
import { APP_CONFIG } from '../../common/constants'
import { useModal } from '../../../../utils/hooks'
import { RenderIf } from '../../../../utils/fns'

const AboutModal = () => {
  const [show, onHide] = useModal(false)

  return (
    <Fragment>
      <Button variant="topNav" className="button topNav__button" onClick={onHide}>
        <TextSnippetTwoToneIcon className="material-icons-two-tone material-icons-two-tone--noinvert" />
        <span className="button__text">About</span>
      </Button>
      {RenderIf(
        show,
        <Modal
          show={show}
          onHide={onHide}
          className="-about"
          header={
            <Modal.Header closeButton>
              <div className="appBrandingGroup">
                <SvgIcon
                  src={APP_CONFIG.inversedLogoUrl}
                  svgClasses="iconic-sm appLogo ml-0 w-100"
                  alt="RWS Logo"
                />
                <div className="aboutAppHeading">
                  <div className="aboutAppAcronym">
                    <span className="aboutAppAcronym__label"></span>
                    {APP_CONFIG.appCode}
                  </div>
                  <div className="aboutAppFullName">{APP_CONFIG.appName}</div>
                </div>
              </div>
            </Modal.Header>
          }
        >
          <Fragment>
            <p className="intro">
              The Roof-to-Wall Selector allows you to find the most cost-effective connector based
              on installation type, connector options and demand loads with the assistance of 3D
              visualization. This application is the web-based version of the Hurricane Tie tab in
              Connector Selector with additional product mix including product finishes.
            </p>

            <h4>
              <span className="release-number">{APP_CONFIG.appVersion}</span>
              <span className="release-date">Released on May 08, 2025</span>
            </h4>
            <ul className="release-note">
              <li>
                <div className="release-type release-addition">
                  <SvgIcon
                    src="assets/images/iconic/fork.svg"
                    svgClasses="iconic-sm"
                    alt="Change"
                  />
                  Addition
                </div>
                <div className="release-info">
                  Add Strong-Drive&reg; SWD Double-Threaded&trade; Screw for Truss/Rafter-to-Top
                  Plate Connections
                </div>
              </li>
            </ul>

            <h4>
              <span className="release-number">{APP_CONFIG.appVersion}</span>
              <span className="release-date">Released on January 09, 2025</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-initial">
                  <SvgIcon src="assets/images/iconic/gear.svg" alt="Change Icon" />
                  Change
                </div>
                <div className="release-info">Maintenance</div>
              </li>
            </ul>

            <h4>
              <span className="release-number">1.3.1</span>
              <span className="release-date">Released on November 14, 2024</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-initial">
                  <SvgIcon src="assets/images/iconic/gear.svg" alt="Change Icon" />
                  Change
                </div>
                <div className="release-info">Maintenance</div>
              </li>
              <li>
                <div className="release-type release-bugFix">
                  <SvgIcon src="assets/images/iconic/bug.svg" alt="Bug Fix Icon" />
                  Bug Fix
                </div>
                <div className="release-info">Minor bug fixes</div>
              </li>
            </ul>

            <h4>
              <span className="release-number">1.3.0</span>
              <span className="release-date">Released on August 08, 2024</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-bugFix">
                  <SvgIcon src="assets/images/iconic/bug.svg" alt="Bug Fix Icon" />
                  Bug Fix
                </div>
                <div className="release-info">Minor bug fixes</div>
              </li>
            </ul>

            <h4>
              <span className="release-number">1.2.0</span>
              <span className="release-date">Released on January 11, 2024</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-addition">
                  <SvgIcon
                    src="assets/images/iconic/fork.svg"
                    svgClasses="iconic-sm"
                    alt="Change"
                  />
                  Addition
                </div>
                <div className="release-info">
                  Updates to Database based on the Wood Construction Connectors Catalog{' '}
                  <a
                    target="_blank"
                    href="https://www.strongtie.com/resources/literature/wood-construction-connectors-catalog"
                    rel="noreferrer"
                  >
                    (C-C-2024)
                  </a>
                </div>
              </li>
              <li>
                <div className="release-type release-bugFix">
                  <SvgIcon src="assets/images/iconic/bug.svg" alt="Bug Fix Icon" />
                  Bug Fix
                </div>
                <div className="release-info">Minor bug fixes</div>
              </li>
            </ul>

            <h4>
              <span className="release-number">1.1.0</span>
              <span className="release-date">Released on December 14, 2023</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-bugFix">
                  <SvgIcon src="assets/images/iconic/bug.svg" alt="Bug Fix Icon" />
                  Bug Fix
                </div>
                <div className="release-info">Minor bug fixes for 3D Viewer</div>
              </li>
            </ul>
            <h4>
              <span className="release-number">1.0.0</span>
              <span className="release-date">Released on June 29, 2023</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-initial">
                  <SvgIcon src="assets/images/iconic/magic-wand.svg" />
                  Initial
                </div>
                <div className="release-info">Initial release of the application</div>
              </li>
            </ul>
          </Fragment>
        </Modal>,
      )}
    </Fragment>
  )
}

export default AboutModal
